import React from "react";
import { Box, Typography } from "@mui/material";

interface TableCountHeaderProps {
  count: number;
}

export const TableCountHeader: React.FC<TableCountHeaderProps> = ({ count }) => {
  return (
    <Box
      sx={{
        background: "#f2f4f7",
        borderBottom: "1px solid #eaecf0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1,
        borderTopLeftRadius: 0.75,
        borderTopRightRadius: 0.75,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: "rgba(0,0,0,0.87)",
        }}
      >
        {count} {count === 1 ? "Log" : "Logs"}
      </Typography>
    </Box>
  );
};
